import { useMemo } from 'react'
import { useGetQueryBlueprintByCode } from '../../../../api/denali'

/**
 * Fetches a blueprint by code (with definition included) and resolves
 * the presentation config for the given key.
 *
 * React Query deduplicates requests automatically — multiple components
 * using the same blueprintCode share one network call.
 */
export default function useBlueprintPresentation (blueprintCode, presentationKey) {
  const {
    data: blueprint,
    isLoading,
    error
  } = useGetQueryBlueprintByCode(blueprintCode, {
    includes: { definition: true }
  })

  const definition = blueprint?.definition ?? null

  const presentationConfig = useMemo(() => {
    if (!definition?.presentation?.options) return null
    return definition.presentation.options[presentationKey] ?? null
  }, [definition, presentationKey])

  return {
    blueprint,
    definition,
    presentationConfig,
    isLoading,
    error
  }
}
